import { api_GET, api_POST, api_PUT } from "./_api.js";
import { getSessionCookie } from "../helpers/cookies.js";

const secretaria_api = {
  getList: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET("Secretaria/GetList")
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getItem: (id) => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Secretaria/GetItem/${id}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getLogotipo: (secretaria_Id = 0) => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Secretaria/GetLogotipo/${secretaria_Id}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  post: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST("Secretaria", json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  put: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_PUT("Secretaria", json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
}

export default secretaria_api;
